import { TextLongIcon } from './TextLongIcon';

/**
 * author: Google
 * id CA8CE1CF-1F6E-4B8B-9972-B3F36E865E67
 * name text-long
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-long.svg
 * tags
 */
export const TextSubjectIcon = TextLongIcon;
export default TextSubjectIcon